import { alpha, Box, LinearProgress, linearProgressClasses, styled, Typography, useMediaQuery } from "@mui/material";
import { fontWeight } from "config/Theme/options";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";

export const Card = styled(Box)(({ theme }) => {
  const { colors } = useMUIThemeModeContext();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return {
    backgroundColor: alpha(colors.gray450, 0.1),
    borderRadius: "10px",
    padding: isMobile ? theme.spacing(1.5) : theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    gap: isMobile ? theme.spacing(1) : theme.spacing(3),
    height: "100%",
  };
});

export const CardTitle = styled(Typography)(({ theme }) => {
  const { colors } = useMUIThemeModeContext();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return {
    fontSize: isMobile ? "0.75rem" : "0.875rem",
    fontWeight: fontWeight.semiBold,
    color: colors.gray500,
  };
});

export const CardContent = styled(Box)(({ theme }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: isMobile ? theme.spacing(1) : theme.spacing(3),
  };
});

export const BadgeProgress = styled(LinearProgress)(({ theme }) => {
  const { colors } = useMUIThemeModeContext();

  return {
    height: 18,
    borderRadius: 90,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: colors.gray200,
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 90,
      backgroundColor: theme.palette.tertiary.main,
    },
  };
});
